import { Pipe, PipeTransform } from '@angular/core';

import { FixRateService } from '@personal-area/global/accounts/services';

@Pipe({
  name: 'fixRateCurrencyConverter',
  pure: false,
  standalone: true,
})
export class FixRateCurrencyConverterPipe implements PipeTransform {
  constructor(private _fixRateService: FixRateService) {}

  public transform(currency: string): string {
    return this._fixRateService.getOriginalCurrency(currency);
  }
}
